import React from "react";
import { cn } from "../lib/utils";

const PRIORITY_LABEL = {
  very_high: "Very High",
  high: "High",
  medium: "Medium",
  low: "Low",
  minimal: "Minimal",
};

const PRIORITY_STYLE = {
  very_high: "bg-red-600 text-white",
  high: "bg-orange-500 text-white",
  medium: "bg-amber-400 text-amber-950",
  low: "bg-emerald-200 text-emerald-900",
  minimal: "bg-emerald-700 text-white",
};

export function PriorityBadge({ priority, score, size = "sm", className }) {
  if (!priority) return null;
  const label = PRIORITY_LABEL[priority] || priority;
  const style = PRIORITY_STYLE[priority] || "bg-slate-200 text-slate-700";
  const sizes = {
    sm: "px-1.5 py-0.5 text-[10px]",
    md: "px-2 py-1 text-xs",
    lg: "px-3 py-1.5 text-sm",
  };
  return (
    <span
      data-testid={`priority-${priority}`}
      className={cn("inline-flex items-center gap-1 font-bold uppercase tracking-wider", style, sizes[size], className)}
    >
      {label}
      {typeof score === "number" && <span className="font-mono opacity-80">· {score}</span>}
    </span>
  );
}

export const PRIORITY_OPTIONS = [
  { value: "very_high", label: "Very High (80-100)" },
  { value: "high", label: "High (60-79)" },
  { value: "medium", label: "Medium (40-59)" },
  { value: "low", label: "Low (20-39)" },
  { value: "minimal", label: "Minimal (<20)" },
];
